module.exports = __webpack_public_path__ + "media/images/post/icon_related_arrow-65ed357a2d8d022714302ac5f9f9eb41.png";